import { useSelector } from 'react-redux';
import { selectLanguage } from '../app/reducers/language';
import { selectTranslations } from '../app/reducers/translations';

export const useTranslation = () => {
  const language = useSelector(selectLanguage);
  const translations = useSelector(selectTranslations);
  
  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      if (value && typeof value === 'object') {
        value = value[k];
      } else {
        return key;
      }
    }
    
    return value || key;
  };
  
  const tMixed = (text) => {
    if (!text) return text;
    return text.replace(/i18n_([\w.]+)/g, (match, key) => t(key));
  };
  
  return { t, tMixed, language };
};
